<template functional>
  <div class="ine-form__title-wrapper" :class="data.staticClass || ''">
    <h1 :class="['ine-form__title', !props.tagline && 'title--no-tagline']">
      {{ props.header }}
    </h1>
    <p class="ine-form__tagline" v-html="props.tagline"></p>
    <small v-if="props.alert && props.alert.length" class="ine-form__alert">{{
      props.alert
    }}</small>
  </div>
</template>

<script>
export default {
  name: 'Title',
  props: {
    header: {
      type: String,
      required: true,
    },
    tagline: {
      type: String,
      required: false,
    },
    alert: {
      type: String,
      required: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.title {
  &--no-tagline {
    padding: 0;
    margin-bottom: -20px;
  }
}
</style>
